import { render, staticRenderFns } from "./block-emails.vue?vue&type=template&id=64b4da4c"
import script from "./block-emails.vue?vue&type=script&lang=js"
export * from "./block-emails.vue?vue&type=script&lang=js"
import style0 from "./block-emails.vue?vue&type=style&index=0&id=64b4da4c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports